export default {
    zh: {
        title: 'FPA-LTO Campaign',
        detail: 'FPA-LTO Campaign > 详情',
        fpaNameCheck: '请维护FPA名称',
        download: '下载',
        import: '上传',
        update: '更新',
        localItem: '供应物料&#',
        localItemContrast: '对比物料&#',
        approver: '审批人',
        saveRemark: '保存Remarks',
        pleaseMaintainPQCP: '请先维护物料信息!',
        PQCPError: '部分PQCP信息有误，请修改后再操作!',
        pleaseMaintainMaterial: '',
        localItemExists: '重复的物料编号!',
        salesStartDateCheck: '请维护 Sales Start Date',
        canNotFindMaterial: '未找到{0}对应物料',
        canNotFindMaterial1: '未找到{0}对应对比物料',
        salesEndDateCheck: '请维护 Sales End Date',
        campaignStartDateCheck: '请维护 Campaign Start Date',
        campaignEndDateCheck: '请维护 Campaign End Date',
        totalEstimatedAmountCheck: '没有维护totalEstimatedAmount',
        uploadDetailsCheck: '行项目{0}：请先下载Excel附件，完善信息后上传，再点击提交！'
    },
    en: {
        title: 'FPA-LTO Campaign',
        detail: 'FPA-LTO Campaign > View',
        fpaNameCheck: 'Please maintain FPA name',
        download: 'download',
        import: 'import',
        update: 'update',
        saveRemark: 'Save Remarks',
        localItem: 'Local Item&#',
        localItemContrast: 'Contrast Local Item&#',
        approver: 'Approver',
        canNotFindMaterial: 'Can not find material {0}',
        pleaseMaintainPQCP: 'Please maintain material info',
        PQCPError: 'Part of PQCP information is wrong, please modify before operation!',
        localItemExists: 'This local item has existed!',
        salesStartDateCheck: 'Please maintain sales start date',
        salesEndDateCheck: 'Please maintain sales end date',
        campaignStartDateCheck: 'Please maintain Campaign Start Date',
        campaignEndDateCheck: 'Please maintain Campaign End Date',
        totalEstimatedAmountCheck: 'have not maintain total estimated amount',
        uploadDetailsCheck: 'Line {0}, please upload details info first!'
    }
}